import { GridFilterOperator } from '@mui/x-data-grid';
import { ONBOARD_DEVICE_NUMERIC_FILTER_FIELDS } from '../../utils/onboardDevicesTable';
import { SERVER_NUMERIC_FILTER_OPERATORS, SERVER_STRING_FILTER_OPERATORS } from './defaultFilterOperators';
import { SERVER_HARDWARE_CONFIGURATION_FILTER_OPERATOR } from './HardwareConfigurationFilterInput';
import { SERVER_ORGANIZATION_FILTER_OPERATOR } from './OrganizationFilterInput';

const CUSTOM_FILTER_OPERATORS_BY_FIELD: Record<string, GridFilterOperator[]> = {
    hardwareConfiguration: [SERVER_HARDWARE_CONFIGURATION_FILTER_OPERATOR],
    organization: [SERVER_ORGANIZATION_FILTER_OPERATOR],
};

export const getOnboardDeviceFilterOperators = (field: string): GridFilterOperator[] => {
    const customOperators = CUSTOM_FILTER_OPERATORS_BY_FIELD[field];

    if (customOperators) {
        return customOperators;
    }

    return ONBOARD_DEVICE_NUMERIC_FILTER_FIELDS.has(field)
        ? SERVER_NUMERIC_FILTER_OPERATORS
        : SERVER_STRING_FILTER_OPERATORS;
};
